import React from 'react';
import { MessageCircle, Minimize2, X } from 'lucide-react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogCompactHeader,
  compactDialogShellClass,
} from '../ui/dialog.tsx';
import { Button } from '../ui/button.tsx';
import ChatPanel from './ChatPanel';
import AdminChatInbox from './AdminChatInbox';

const headerIconButtonClass =
  'absolute top-3.5 z-10 h-7 w-7 shrink-0 rounded-sm opacity-70 hover:opacity-100';

/** Expanded, focused conversation view. Admin gets inbox + thread side by side. */
const ChatModal = ({
  open,
  onOpenChange,
  onCollapse,
  viewer,
  user,
  threadEmail,
  unreadCount = 0,
  threads = [],
  selectedThreadEmail,
  onSelectThread,
}) => {
  const isAdmin = viewer === 'admin';
  const selectedThread = isAdmin
    ? threads.find((t) => t.id === selectedThreadEmail) || null
    : null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideCloseButton
        className={`w-[calc(100vw-2rem)] max-w-[calc(100vw-2rem)] h-[calc(100dvh-2rem)] max-h-[calc(100dvh-2rem)] bg-card text-card-foreground ${compactDialogShellClass}`}
      >
        {typeof onCollapse === 'function' ? (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={`${headerIconButtonClass} right-12`}
            onClick={onCollapse}
            aria-label="Collapse to chat widget"
          >
            <Minimize2 className="h-4 w-4" />
          </Button>
        ) : null}
        <DialogClose asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={`${headerIconButtonClass} right-3`}
            aria-label="Close chat"
          >
            <X className="h-4 w-4" />
          </Button>
        </DialogClose>
        <DialogCompactHeader
          icon={MessageCircle}
          title={isAdmin ? 'Support chats' : 'Support chat'}
          description={
            isAdmin
              ? 'Conversations with users across the platform'
              : 'Chat with the Advicelink team — screenshots welcome'
          }
          className={typeof onCollapse === 'function' ? 'pr-20' : 'pr-12'}
        />
        {isAdmin ? (
          <div className="flex-1 min-h-0 flex">
            <div className="w-72 shrink-0 border-r border-border flex flex-col min-h-0">
              <AdminChatInbox
                threads={threads}
                selectedThreadEmail={selectedThreadEmail}
                onSelectThread={onSelectThread}
                currentUserEmail={user?.email}
              />
            </div>
            {selectedThreadEmail ? (
              <ChatPanel
                key={selectedThreadEmail}
                threadEmail={selectedThreadEmail}
                viewer="admin"
                user={user}
                active={open}
                unreadCount={Number(selectedThread?.unreadForAdmin) || 0}
              />
            ) : (
              <div className="flex-1 min-h-0 flex items-center justify-center text-sm text-muted-foreground">
                Select a conversation to view messages
              </div>
            )}
          </div>
        ) : (
          <ChatPanel
            threadEmail={threadEmail}
            viewer="user"
            user={user}
            active={open}
            unreadCount={unreadCount}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ChatModal;
